import { useState, useRef, useEffect } from 'react';
import styled from 'styled-components';
import get from 'lodash/get';
import NavLink from '../../atoms/NavLink';
import { mq } from '~/styles/grid';

import NavToggler from '~/components/molecules/Navigation/NavigationToggler';

const Wrapper = styled.div`
  background: ${(props) => props.theme.color.gray400};
  padding: 5px 3% 2px;
  position: sticky;
  z-index: 99999;
  top: 0;
  left: 0;

  a {
    color: ${(props) => props.theme.color.primary800};
  }

  @media (${mq.mdDown}) {
    padding: 0;
  }
`;

const NavLinkStyled = styled(NavLink)`
  margin-right: 25px;

  &:last-of-type {
    margin-right: 0;
  }
`;

const Btn = styled.div`
  display: none;

  @media (${mq.mdDown}) {
    display: inline-block;
  }
`;

const Links = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;

  @media (${mq.mdDown}) {
    flex-direction: column;
    align-items: flex-start;
    display: ${(props) => (props.isOpened ? 'flex' : 'none')};
    padding: 10px 17px 20px;
  }
`;

/**
 * @param {EditorNavProps} props
 * @returns {React.ReactElement} The rendered component
 */
const EditorNav = ({ navLinks, height = () => 0 }) => {
  const [isOpened, toggleOpenedState] = useState(false);
  const [navHeight, setNavHeight] = useState(0);
  const navRef = useRef(null);

  /* eslint-disable react-hooks/exhaustive-deps */
  useEffect(() => {
    if (navRef.current) {
      setNavHeight(get(navRef, 'current.clientHeight', 0));
    }
    height(navHeight);
  });
  /* eslint-enable react-hooks/exhaustive-deps */

  return (
    <Wrapper ref={navRef}>
      <Btn>
        <NavToggler
          onChange={() => toggleOpenedState(!isOpened)}
          checked={isOpened}
        />
      </Btn>
      <Links isOpened={isOpened}>
        {navLinks &&
          navLinks.map((link, idx) => <NavLinkStyled key={idx} {...link} />)}
      </Links>
    </Wrapper>
  );
};

export default EditorNav;
